module.exports = __webpack_public_path__ + "img/qq@3x.e8da99ae.png";